import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { translateError } from 'app/lib/error';
import { DefaultErrorPropType } from 'app/lib/proptypes';
import { Snackbar, SnackbarMessage, SnackbarVariant } from 'app/components/core/Snackbar';

export function DownloadFailedNotification({
    id,
    error = null,
    onDismiss,
    viewName,
    targetName = null
}) {
    const { t } = useTranslation();
    let message;

    if (targetName) {
        message = t(`notifications:DownloadExplorationFailed`, {
            viewName,
            targetName,
            message: translateError(t, error)
        });
    } else {
        message = t(`notifications:DownloadFailed`, {
            viewName,
            message: translateError(t, error)
        });
    }

    return (
        <Snackbar
            id={id}
            onDismiss={onDismiss}
            variant={SnackbarVariant.ERROR}
            enableShowDetailsIfTruncated
            message={message}>
            <SnackbarMessage>{message}</SnackbarMessage>
        </Snackbar>
    );
}

DownloadFailedNotification.propTypes = {
    id: PropTypes.string.isRequired,
    onDismiss: PropTypes.func.isRequired,
    viewName: PropTypes.string.isRequired,
    targetName: PropTypes.string,
    error: DefaultErrorPropType
};
